import { newWorkbookForPublishedConnection } from '~src/app/actions/spaces/NewWorkbookForPublishedConnectionAction';
import { EntityActionNames,IEntityAction } from '~src/app/spaces/ActionsMenu/EntityActions/IEntityAction';
import { isSingleEmbeddedDatasource } from '~src/app/spaces/ActionsMenu/EntityActions/IEntityActionHelpers';
import { hideLaunchEditOnMobile } from '~src/app/utils/MobileHelper';
import { Messages } from '~src/codegen/Localize';
import { IContentInfo } from '~src/ts/models/IContentInfo';
import { ILaunchWebAuthoringAction } from '~src/ts/ServerApi/types/actionNames';

import { newWorkbookForDatasource } from '../actions/NewWorkbookForDatasourceAction';


export const NewWorkbookEntityAction: IEntityAction<IContentInfo<'datasource' | 'publishedConnection'>, ILaunchWebAuthoringAction> = {
  name: EntityActionNames.NewWorkbook,
  translateName: Messages.newWorkbook,
  isVisible: (targetItems: IContentInfo[]) => {
    return !isSingleEmbeddedDatasource(targetItems) && !hideLaunchEditOnMobile();
  },
  isClickable: (availableActions: ILaunchWebAuthoringAction, targetItems: IContentInfo[]) =>
      targetItems.length === 1 && availableActions && availableActions.launchWebAuthoring,
  createReduxAction: (targetItems: IContentInfo[]) => {
    if (targetItems.length !== 1) {
      return;
    }

    const item = targetItems[0];
    if (item.contentType === 'datasource') {
      return newWorkbookForDatasource(item);
    } else if (item.contentType === 'publishedConnection') {
      return newWorkbookForPublishedConnection(item);
    }
  }
};
